
/*@jsxRuntime automatic @jsxImportSource react*/
/*prettier-ignore*/
/*prettier-ignore*/
/*prettier-ignore*/
export const attributes = {
  "authors": ["chase-merlin", "ben-milne", "cody-lambert"],
  "callToAction": {
    "heading": "List your stablecoin",
    "subheading": "Submit a listing request to join Brale Business.",
    "button": "Request Listing",
    "ctaUrl": "https://docs.google.com/forms/d/e/1FAIpQLSeXoj_PbEyRHvuRDfbTcY82G9NFrFc3Yb028Uo_3095LtsSMA/viewform",
    "externalUrl": true
  },
  "coverImage": {
    "alt": "Announcing support for USDC on Base, Arbitrum, and Celo | Brale Blog",
    "url": "/assets/blog/announcing-support-for-usdc-on-base-arbitrum-celo/cover.svg"
  },
  "date": "2024-08-01",
  "description": "Brale Business accounts support onramping, offramping, and swapping native USDC on Base, Arbitrum, and Celo. Learn more about Brale Business accounts.",
  "discussLinkedIn": "https://www.linkedin.com/posts/brale_announcing-support-for-usdc-on-base-arbitrum-activity-7224800264392749060-KeF8/",
  "discussTwitter": "https://x.com/brale_xyz/status/1819034789967442129",
  "discussFarcaster": "https://warpcast.com/brale/0x00770d5a",
  "excerpt": "Brale Business accounts now support native USDC on Base, Arbitrum, and Celo.",
  "ogImage": {
    "alt": "Announcing support for USDC on Base, Arbitrum, and Celo | Brale Blog",
    "url": "/assets/blog/announcing-support-for-usdc-on-base-arbitrum-celo/og-image.png"
  },
  "timeOverride": 2,
  "title": "Announcing support for USDC on Base, Arbitrum, and Celo",
  "contracts": [{
    "chainId": "base",
    "contract": "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
    "transferCost": "$0.005",
    "url": "https://basescan.org"
  }, {
    "chainId": "arbitrum",
    "contract": "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
    "transferCost": "$0.007",
    "url": "https://arbiscan.io"
  }, {
    "chainId": "celo",
    "contract": "0xcebA9300f2b948710d2653dD7B07f33A8B32118C",
    "transferCost": "$0.0002",
    "url": "https://celoscan.io"
  }],
  "fees": {
    "offchain": [{
      "type": "Wire",
      "depositFee": "$0",
      "withdrawFee": "$0"
    }, {
      "type": "ACH",
      "depositFee": "$0",
      "withdrawFee": "$0"
    }],
    "onchain": [{
      "type": "USDC",
      "depositFee": "$0",
      "withdrawFee": "$0"
    }, {
      "type": "USDP",
      "depositFee": "$0",
      "withdrawFee": "$0"
    }, {
      "type": "PYUSD",
      "depositFee": "$0",
      "withdrawFee": "$0"
    }]
  }
};
import {BlockchainIcon} from "~/components/logos/blockchain";
import {ExternalLink} from "~/components/site/external-link";
import {faArrowUpRight} from "@fortawesome/pro-light-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {FormattedNumber} from "~/components/stablecoins/formatted-number";
import {SummaryCard} from "~/components/stablecoins/summary-card";
import {Token as TokenElement} from "~/components/stablecoins/token";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a",
    li: "li",
    tr: "tr",
    td: "td",
    h2: "h2",
    img: "img"
  }, props.components);
  return <><_components.p>{"We’re excited to announce that "}<_components.a href="/blog/introducing-brale-business-accounts">{"Brale Business accounts"}</_components.a>{" now support native USDC on Base, Arbitrum, and Celo. Business accounts support free USDC onramping, offramping, and 1:1 swaps with Brale-issued stablecoins. This extends account support alongside USDC on Ethereum, Polygon, Avalanche, and Optimism, and USDP on Solana."}</_components.p>{"\n"}<div className="mt-8 mb-4 gap-x-6 not-prose"><div className="grid grid-rows-1 sm:grid-cols-2 gap-x-6 gap-y-4"><SummaryCard description="Total Supply*"><div className="flex items-center gap-x-3"><_components.p><FormattedNumber value={31220855084} />{" USD"}</_components.p></div></SummaryCard><SummaryCard description="Contracts"><ul className="flex gap-x-3 list-none">{attributes.contracts.map(c => <_components.li>
            <ExternalLink className="flex items-center" title="View on explorer" href={`${c.url}/token/${c.contract}`}>
              <BlockchainIcon chainId={c.chainId} />
            </ExternalLink>
          </_components.li>)}</ul></SummaryCard></div></div>{"\n"}{}{"\n"}<span className="not-prose text-gray-500 dark:text-gray-400 text-sm">{"*Total supply on 07/31/2024"}</span>{"\n"}<_components.p>{"The native contract addresses of native USDC on Base, Arbitrum, and Celo are listed below, along with a comparison of average transaction fees."}</_components.p>{"\n"}<div className="border border-primary round overflow-x-scroll bg-white dark:bg-black p-6 md:p-8 mt-8 mb-8"><table className="table-auto m-0"><thead><tr><th className="text-secondary">{"Chain"}</th><th className="text-secondary">{"Native USDC Contract"}</th><th className="text-secondary whitespace-nowrap">{"Transfer Cost"}</th><th className="w-1/4" /></tr></thead><tbody>{attributes.contracts.map(c => <_components.tr key={c.deploymentId}>
          <_components.td>
            <BlockchainIcon chainId={c.chainId} className="mr-2 inline-block" />
          </_components.td>
          <_components.td className="whitespace-nowrap">
            <ExternalLink title="View on explorer" href={`${c.url}/token/${c.contract}`} className="text-primary">
              {c.contract}
              <FontAwesomeIcon className="h-4 w-4 ml-1 text-secondary" icon={faArrowUpRight} />
            </ExternalLink>
          </_components.td>
          <_components.td className="text-primary">{c.transferCost}</_components.td>
        </_components.tr>)}</tbody></table></div>{"\n"}<_components.h2>{"Onramp, Offramp, and Swap with USDC"}</_components.h2>{"\n"}<_components.p>{"Swap "}<_components.a href="/stablecoins/SBC">{"SBC"}</_components.a>{", "}<_components.a href="/stablecoins/USDGLO">{"USDGLO"}</_components.a>{", "}<_components.a href="/stablecoins/MXNe">{"MXNe"}</_components.a>{", "}<_components.a href="/stablecoins/USC">{"USC"}</_components.a>{", and all Brale supported stablecoins at par on a fully 1:1 basis with "}<_components.a href="/stablecoins/USDP">{"USDP"}</_components.a>{" and "}<_components.a href="/stablecoins/USDC">{"USDC"}</_components.a>{"."}</_components.p>{"\n"}{}{"\n"}<div className="round border border-primary not-prose my-10 overflow-clip"><_components.p><_components.img src="/assets/blog/announcing-support-for-usdc-on-base-arbitrum-celo/mint-with-usdc-on-arbitrum.gif" alt="Minting USDGLO with USDC on Arbitrum as funding source" /></_components.p></div>{"\n"}<_components.p>{"Business accounts support free stablecoin onramps and offramps via off-chain and on-chain funding methods."}</_components.p>{"\n"}{}{"\n"}<div className="border border-primary round overflow-x-auto bg-white dark:bg-black p-6 md:p-8 mt-8 mb-8"><table className="table-auto m-0 w-full text-base"><thead><tr><th className="px-4 w-1/3" /><th className="px-4 w-1/3"><span className="whitespace-nowrap">{"Deposit Fee"}</span>{" (Onramp)"}</th><th className="px-4 w-1/3"><span className="whitespace-nowrap">{"Withdraw Fee"}</span>{" (Offramp)"}</th></tr></thead><tbody><tr><td className="px-4 whitespace-nowrap"><strong>{"Offchain"}</strong></td><td className="px-4" /><td className="px-4" /></tr>{attributes.fees.offchain.map(f => <_components.tr key={f.type}>
          <_components.td className="px-4">{f.type}</_components.td>
          <_components.td className="px-4">{f.depositFee}</_components.td>
          <_components.td className="px-4">{f.withdrawFee}</_components.td>
        </_components.tr>)}<tr><td className="px-4 whitespace-nowrap"><strong>{"Onchain"}</strong></td><td className="px-4" /><td className="px-4" /></tr>{attributes.fees.onchain.map(f => <_components.tr key={f.type}>
          <_components.td className="px-4">{f.type}</_components.td>
          <_components.td className="px-4">{f.depositFee}</_components.td>
          <_components.td className="px-4">{f.withdrawFee}</_components.td>
        </_components.tr>)}</tbody></table></div>{"\n"}<_components.p>{"We're excited to support access to stablecoins and interoperability between Brale-issued stablecoins and the broader stablecoin ecosystem. If you'd like to see additional stablecoins supported, please fill out our listing form, and our team will reach out to you."}</_components.p></>;
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}
export default MDXContent;


export const filename = "announcing-support-for-usdc-on-base-arbitrum-celo.mdx";
export const headers = typeof attributes !== "undefined" && attributes.headers;
export const meta = typeof attributes !== "undefined" && attributes.meta;
export const handle = typeof attributes !== "undefined" && attributes.handle;
    